import { createRouter, createWebHistory } from "vue-router";

// import Home from "./views/home";
// import defaultLayout from "./layouts/side-nav-inner-toolbar";
import menuApplication from "./layouts/menu-application";
import none from "./layouts/none";
// import simpleLayout from "./layouts/single-card";

function loadView(view) {
    return () => import(`./views/${view}.vue`);
}
function loadViewIndex(view) {
    return () => import(`./views/${view}/index.vue`);
}

export default function ($Core, $i18n, $Helper) {
    const router = new createRouter({
        routes: [
            {
                path: "/",
                name: "home",
                meta: {
                    requiresAuth: true,
                    layout: menuApplication,
                },
                component: loadView("home"),
            },
            {
                path: "/Quan-Ly-Thong-Tin/Doanh-Nghiep",
                name: "DanhSachDoanhNghiep",
                meta: {
                    requiresAuth: false,
                    layout: menuApplication,
                    title: "Danh sách doanh nghiệp",
                },
                component: loadViewIndex("Quan-Ly-Thong-Tin/Doanh-Nghiep"),
            },
            {
                path: "/Quan-Ly-Thong-Tin/Nhan-Vien",
                name: "DanhSachNhanVien",
                meta: {
                    requiresAuth: false,
                    layout: menuApplication,
                    title: "Danh sách nhân viên",
                },
                component: loadViewIndex("Quan-Ly-Thong-Tin/Nhan-Vien"),
            },
            {
                path: "/Quan-Ly-Thong-Tin/Nhom-The",
                name: "DanhSachNhomThe",
                meta: {
                    requiresAuth: false,
                    layout: menuApplication,
                    title: "Danh sách nhóm thẻ",
                },
                component: loadViewIndex("Quan-Ly-Thong-Tin/Nhom-The"),
            },
            {
                path: "/Quan-Ly-Thong-Tin/The-Kiem-Soat",
                name: "DanhSachTheKiemSoat",
                meta: {
                    requiresAuth: false,
                    layout: menuApplication,
                    title: "Danh sách thẻ kiểm soát",
                },
                component: loadViewIndex("Quan-Ly-Thong-Tin/The-Kiem-Soat"),
            },
            {
                path: "/Bao-Cao/Lich-Su-Cap-The",
                name: "DanhSachLichSuCapThe",
                meta: {
                    requiresAuth: false,
                    layout: menuApplication,
                    title: "Danh sách lịch sử cấp thẻ",
                },
                component: loadViewIndex("Bao-Cao/Lich-Su-Cap-The"),
            },
            {
                path: "/Bao-Cao/Ve-Doanh-Nghiep-Tu-Khai-Bao",
                name: "Ve-Doanh-Nghiep-Tu-Khai-Bao",
                meta: {
                    requiresAuth: false,
                    layout: menuApplication,
                    title: "Danh sách vé doanh nghiệp tự khai báo",
                },
                component: loadViewIndex("Bao-Cao/Ve-Doanh-Nghiep-Tu-Khai-Bao"),
            },
            {
                path: "/Bao-Cao/Ve-Kiem-Soat-Tai-Cong",
                name: "Ve-Kiem-Soat-Tai-Cong",
                meta: {
                    requiresAuth: false,
                    layout: menuApplication,
                    title: "Danh sách vé kiểm soát tại cổng",
                },
                component: loadViewIndex("Bao-Cao/Ve-Kiem-Soat-Tai-Cong"),
            },
            {
                path: "/Khai-Bao-Ve",
                name: "Khai-Bao-Ve",
                meta: {
                    requiresAuth: false,
                    layout: menuApplication,
                    title: "Khai báo vé",
                },
                component: loadViewIndex("Khai-Bao-Ve"),
            },
            {
                path: "/Thong-Tin-Tai-Khoan",
                name: "Thong-Tin-Tai-Khoan",
                meta: {
                    requiresAuth: false,
                    layout: menuApplication,
                    title: "TT tài khoản",
                },
                component: loadViewIndex("Thong-Tin-Tai-Khoan"),
            },
            {
                path: "/Error",
                name: "Error",
                meta: {
                    requiresAuth: true,
                    layout: none,
                    title: "Lỗi!",
                },
                component: loadView("Error"),
            },

            {
                path: "/",
                redirect: "/home",
            },
            {
                path: "/recovery",
                redirect: "/home",
            },
            {
                path: "/:pathMatch(.*)*",
                redirect: "/Error?statusCode=404",
            },
        ],
        history: createWebHistory(process.env.BASE_URL),
    });

    router.beforeEach((to, from, next) => {
        console.log("abcd", $Core);
        if (to.name === "login-form" && $Core.Auth.IsAuth) {
            next({ name: "home" });
        }
        if (!$Core.Auth.IsAuth) {
            $Core.Auth.Login();
            // next({
            //     name: "login-form",
            //     query: { redirect: to.fullPath }
            // });
        } else {
            if (to.meta.requiresAuth == true || to.meta.requiresAuth == false) {
                next();
            } else {
                if (
                    $Helper.Common.CheckRole(
                        $i18n.global.t("Quyen.TypeQLTT"),
                        $i18n.global.t("Quyen." + to.meta.requiresAuth)
                    )
                ) {
                    next();
                } else {
                    next({
                        name: "Error",
                        query: {
                            statusCode: 403,
                        },
                    });
                }
            }
        }
    });
    return router;
}
